import { Link } from "react-router-dom";
import "../components/categories.css";


const babyCategories = [
    {
name:"Hospital Sets",
path:"/category/Baby/Hospital Sets",
image:"https://i.postimg.cc/k43bqj9W/Whats-App-Image-2026-08-01-at-1-51-10-PM.jpg"
},

{
name:"Baby Boy",
path:"/category/Baby/Boy",
image:"https://i.postimg.cc/8kLbJ60j/Boy.jpg"
},

{
name:"Baby Girl",
path:"/category/Baby/Girl",
image:"https://i.postimg.cc/Kj5L9t68/Girl.jpg"
},


{
name:"Bodysuits & Rompers",
path:"/category/Baby/Bodysuits & Rompers",
image:"https://i.postimg.cc/pr1VXT8Q/Bodysuits-Rompers.jpg"
},

{
name:"Accessories",
path:"/category/Baby/Accessories",
image:"https://i.postimg.cc/C5tYp2T3/accessories.jpg"
}

];



function Baby(){

return(

<section className="categories-section">


<h2 className="categories-title">
Baby Section
</h2>



<div className="categories">


{
babyCategories.map((cat,index)=>(


<Link

to={cat.path}

className="category-card"

key={index}

>


<img

src={cat.image}

alt={cat.name}

/>


<h3>
{cat.name}
</h3>


</Link>


))

}


</div>


</section>


);

}


export default Baby;